import { resolveLegacyActionUrl } from "./legacy-action-url";

// Runs before the router is created, so the router boots on the route itself
// and the other params reach it untouched by any search validation.
export function applyLegacyActionUrl(basepath: string): void {
  const target = resolveLegacyActionUrl(window.location.href, basepath);
  if (target !== null) {
    window.history.replaceState(window.history.state, "", target);
  }
}
